import { atom } from 'jotai'

export const startDateAtom = atom(null)
